<template>
  <footer class="app-footer text-white pt-5 pb-3 bg-footer-dark">
    <div class="container">
      
      <div class="row pb-4 border-bottom-light">
        
        <div class="col-lg-4 mb-4 mb-lg-0 animate__fadeInLeft">
          <div class="footer-logo mb-3">
            <i class="bi bi-cpu-fill me-2 fs-3 text-primary footer-icon-spin"></i>
            <span class="fs-4 fw-bold">Compuservicio</span>
          </div>
          <p class="text-white-50">
            Expertos en soluciones informáticas. Conectando tu mundo digital con la máxima eficiencia.
          </p>
          
          <a href="#contacto" class="btn btn-outline-primary mt-2 btn-footer-glow">
            <i class="bi bi-headset me-2"></i> Soporte Rápido
          </a>
        </div>
        
        <div class="col-6 col-lg-2 mb-4 mb-lg-0 animate__fadeInUp animate__delay-0s">
          <h5 class="fw-bold mb-3 text-primary-gradient">Mapa del Sitio</h5>
          <ul class="list-unstyled footer-links">
            <li><a href="#inicio" class="text-white-50 hover-link">Inicio</a></li>
            <li><a href="#sobre-nosotros" class="text-white-50 hover-link">Sobre Nosotros</a></li>
            <li><a href="#servicios" class="text-white-50 hover-link">Nuestros Servicios</a></li>
            <li><a href="#contacto" class="text-white-50 hover-link">Contáctanos</a></li>
          </ul>
        </div>
        
        <div class="col-6 col-lg-3 mb-4 mb-lg-0 animate__fadeInUp animate__delay-1s">
          <h5 class="fw-bold mb-3 text-primary-gradient">Especialidades</h5>
          <ul class="list-unstyled footer-links">
            <li><a href="#servicios" class="text-white-50 hover-link">Formateo y SO</a></li>
            <li><a href="#servicios" class="text-white-50 hover-link">Eliminación de Virus</a></li>
            <li><a href="#servicios" class="text-white-50 hover-link">Mantenimiento Preventivo</a></li>
            <li><a href="#servicios" class="text-white-50 hover-link">Recuperación de Datos</a></li>
          </ul>
        </div>
        
        <div class="col-lg-3 animate__fadeInRight animate__delay-2s">
          <h5 class="fw-bold mb-3 text-primary-gradient">Contacto</h5>
          
          <div class="mt-4 pt-2">
            <p class="text-white-50 small mb-2">
                <i class="bi bi-envelope-fill me-2 text-primary-gradient"></i> 
                <a href="mailto:briantisman@gmail.com" class="text-white-50 hover-link-no-icon">briantisman@gmail.com</a>
            </p>
            <p class="text-white-50 small mb-2">
                <i class="bi bi-phone-fill me-2 text-primary-gradient"></i> 
                <a href="tel:+584123659519" class="text-white-50 hover-link-no-icon">+58 412-3659519</a>
            </p>
            <p class="text-white-50 small mb-0">
                <i class="bi bi-globe me-2 text-primary-gradient"></i> 
                <a href="https://digital-business-card-blond-beta.vercel.app/" target="_blank" class="text-white-50 hover-link-no-icon">Tarjeta Digital</a>
            </p>
          </div>
          </div>

      </div>

      <div class="row pt-4 mt-2">
        <div class="col-12 text-center animate__fadeInUp animate__delay-3s">
          <p class="small text-muted-footer mb-1">
            © {{ new Date().getFullYear() }} Compuservicio. Todos los derechos reservados.
          </p>
          <p class="small text-muted-footer mb-0">
            Diseñado y Creado por 
            <a href="https://digital-business-card-blond-beta.vercel.app/" target="_blank" class="text-primary-gradient fw-bold creator-link">Jefferson Martínez</a>
          </p>
        </div>
      </div>

    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style scoped>
/* IMPORTANTE: Requiere Animate.css para las clases 'animate__' */

/* === Colores y Fondo Principal === */
.bg-footer-dark {
    background-color: #121215; /* Fondo oscuro y profundo */
    border-top: 5px solid #0d6efd; /* Línea de contraste de alta calidad */
}
.text-primary-gradient {
    /* Simula un degradado sutil en los títulos */
    color: #0d6efd;
    text-shadow: 0 0 8px rgba(13, 110, 253, 0.5);
}
.text-muted-footer {
    color: #777;
    text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}
.border-bottom-light {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

/* === Estilo del Logo === */
.footer-icon-spin {
    animation: pulse 2s infinite ease-in-out;
}
@keyframes pulse {
  0% { transform: scale(1); opacity: 0.95; }
  50% { transform: scale(1.03); opacity: 1; }
  100% { transform: scale(1); opacity: 0.95; }
}

/* === Botón de Contacto Rápido === */
.btn-footer-glow {
    border-color: #0d6efd;
    color: #0d6efd;
    font-weight: 600;
    transition: 0.3s;
}
.btn-footer-glow:hover {
    background-color: #0d6efd;
    color: white;
    box-shadow: 0 0 15px rgba(13, 110, 253, 0.7);
    transform: scale(1.05);
}

/* === Enlaces de Navegación === */
.footer-links li {
    margin-bottom: 8px;
}
.hover-link {
    text-decoration: none;
    transition: 0.3s;
    font-size: 0.95rem;
    position: relative;
    padding-left: 15px;
}
/* Efecto de Flecha en Hover */
.hover-link::before {
    content: "\203A"; /* Símbolo de chevrón a la derecha */
    position: absolute;
    left: 0;
    opacity: 0;
    color: #0d6efd;
    transition: 0.3s;
}
.hover-link:hover {
    color: white !important;
    padding-left: 20px;
}
.hover-link:hover::before {
    left: 5px;
    opacity: 1;
}

/* === Íconos de Redes Sociales (Se eliminaron, pero mantengo el estilo por si se añaden) === */
.social-footer-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: rgba(13, 110, 253, 0.1); 
    color: #0d6efd;
    font-size: 1.2rem;
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    box-shadow: 0 0 10px rgba(13, 110, 253, 0.3);
}
.social-footer-btn:hover {
    background-color: #0d6efd;
    color: white;
    transform: rotate(360deg) scale(1.1);
    box-shadow: 0 0 20px rgba(13, 110, 253, 0.9);
}

/* === Nuevos Estilos para los Links de Contacto y Crédito === */
.hover-link-no-icon {
    text-decoration: none;
    transition: 0.3s;
}
.hover-link-no-icon:hover {
    color: white !important;
}
.creator-link {
    text-decoration: none;
    transition: 0.3s;
}
.creator-link:hover {
    color: white !important;
    text-decoration: underline;
}


/* === Animaciones de Entrada (Retardos Ajustados) === */
.animate__delay-0s { animation-delay: 0.3s; } 
.animate__delay-1s { animation-delay: 0.6s; } 
.animate__delay-2s { animation-delay: 0.9s; } 
.animate__delay-3s { animation-delay: 1.2s; } 

.animate__fadeInLeft, .animate__fadeInRight, .animate__fadeInUp {
    animation-duration: 0.8s;
    animation-fill-mode: both;
}

/* === Responsive para Móviles === */
@media (max-width: 991.98px) {
    .bg-footer-dark {
        padding-top: 3rem;
    }
    .col-lg-2, .col-lg-3, .col-lg-4 {
        margin-bottom: 2rem !important;
    }
}
</style>